import i18n from 'i18next';

import borrower from 'shared/language/en/borrower';
import broker from 'shared/language/en/broker';

// todo find a way to load the async based on namespace in useCopy
// without jump in page between updates.
const translation = { borrower, broker };

i18n.init({
  preload: ['en'],
  debug: false,
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: { ...translation }
  },
  parseMissingKeyHandler: () => ''
});

export default i18n;
